import { ELSummaryRequest } from './SummaryModal.types';
import { makeCygnusApiCall } from "../../../api/api";

const generateSummary = async (
    request: ELSummaryRequest,
): Promise<any> => {
    const response = await makeCygnusApiCall({
        type: "POST",
        url: "/engagement-letter/generate_summary/",
        payload: {
            ElId: request.elId,
            FileName: request.elFileName,
            IncludeKeyPoints: request.includeKeyPoints ?? true,
            Question: request.question,
        },
        show_message: false,
        isblob: false,
        forMDM: true,
    });
    
    if(!response) {
        return {
            success: false,
            error: 'Failed to generate summary',
        };
    }
    
    if (response.success) {
        return {
            success: true,
            data: response.data,
            message: response.message || 'Summary generated successfully',
        };
    }
    
    return {
        success: false,
        error: response.message || 'Failed to generate summary',
    };
};


export const summaryService = {
    generateSummary,
};